import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BarChart, Bar, CartesianGrid, Rectangle, Tooltip, XAxis, YAxis, Legend, ResponsiveContainer } from 'recharts';
import { FaUsers } from 'react-icons/fa';

const PaymentChart = () => {
    const apiUrl = process.env.REACT_APP_API_URL
    const [payments, setPayments] = useState([])
    
    useEffect(() => {
        axios.get(`${apiUrl}/payment/getAllPaymentsWithBalance`, {
            headers: {
              loginToken: localStorage.getItem("loginToken")
            }
        })
        .then(res => {
            if(res.data.error){
                console.log(res.data.error)
            }else{
                setPayments(res.data)
            }
        })
        .catch(err => {
            console.log(err)
        })
    }, [])

    // Group payments by agent
    const getAgentPaymentData = (payments) => {
        const agentData = {};

        payments.forEach(item => {
            const agentName = item.Employee?.Agent?.name || 'No Agent';
            
            if (!agentData[agentName]) {
                agentData[agentName] = {
                    name: agentName,
                    collected: 0,
                    due: 0
                };
            }
            
            agentData[agentName].collected += parseFloat(item.totalPayments) || 0;
            agentData[agentName].due += parseFloat(item.balance) || 0;
        });

        return Object.values(agentData);
    };

    const chartData = getAgentPaymentData(payments);

    const CustomBar = (props) => {
        const { x, y, width, height, fill } = props;
        return (
            <Rectangle
                x={x}
                y={y - 10}
                width={width}
                height={height}
                fill={fill}
                radius={[12, 12, 0, 0]}
            />
        );
    };

    const CustomLabel = (props) => {
        const { x, y, width, value } = props;
        const formattedValue = `RM ${Math.round(value)}`;
        return (
            <text 
                x={x + width / 2} 
                y={y - 5} 
                fill="#1f2937" 
                textAnchor="middle" 
                fontSize={10}
                fontWeight="bold"
            >
                {formattedValue}
            </text>
        );
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className="bg-white p-3 rounded-lg shadow-lg border border-gray-200">
                    <p className="text-gray-700 font-semibold">{payload[0].payload.name}</p>
                    {payload.map((entry, index) => (
                        <p key={index} style={{ color: entry.color }} className="font-bold">
                            {entry.name}: RM {Math.round(entry.value).toLocaleString()}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    return (
        <div className="w-full flex flex-col gap-2 pt-2 mb-0">
            <div className="flex items-center gap-2">
                <FaUsers className="text-orange-600 text-xl" />
                <h2 className="text-xl font-bold text-gray-800">Agent Payments</h2>
            </div>
            <p className="text-gray-500 text-sm mb-2">Payment collected and due by agent</p>
            <ResponsiveContainer width='100%' height={350}>
                <BarChart data={chartData} margin={{ top: 20, right: 30, left: 0, bottom: 60 }}>
                    <CartesianGrid strokeDasharray="4 4" stroke="#e5e7eb" vertical={false} />
                    <XAxis 
                        dataKey="name" 
                        tick={{ fontSize: 11, fill: '#6b7280' }}
                        axisLine={{ stroke: '#e5e7eb' }}
                    />
                    <YAxis 
                        tick={{ fontSize: 12, fill: '#6b7280' }}
                        axisLine={{ stroke: '#e5e7eb' }}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend 
                        wrapperStyle={{ paddingTop: '10px' }}
                        iconType="square"
                    />
                    <Bar 
                        dataKey="collected" 
                        name="Collected"
                        fill="#10b981" 
                        label={<CustomLabel />}
                        shape={CustomBar}
                    />
                    <Bar 
                        dataKey="due" 
                        name="Due"
                        fill="#ef4444" 
                        label={<CustomLabel />}
                        shape={CustomBar}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

export default PaymentChart
